import React from "react"
import mountainBroken from "../images/mountain-broken.svg"

export const LuiErrorPage: React.FC<{
  header?: React.ReactElement
  footer?: React.ReactElement
  content?: React.ReactElement
}> = (props) => {
  return (
    <>
      {props.header}
      <div className="g-flex-container margin-top-md margin-bottom-xl">
        <div className="g-flex-row">
          <div className="g-flex-col-sm-7 g-flex-col-lg-6">
            <div className="lui-text-content-area">{props.content}</div>
          </div>
          <div className="g-flex-col-xs-12 g-flex-col-sm-5 g-flex-col-lg-6">
            <img src={mountainBroken} alt="Mountain broken" />
          </div>
        </div>
      </div>
      {props.footer}
    </>
  )
}
